module.exports = __webpack_public_path__ + "img/icon-auth.ea862105.svg";